import { canNavigate, ConductorOneChildActive, Router, ScreenBase, splitUrlSegments } from "@frui.ts/screens";
import LocalizationService from "services/localizationService";
import LicensePlateChangeViewModel, { LicensePlateChangeNoticeNavigationName } from "./licensePlateChangeViewModel";
import LicensePlateChangeDocumentsUploadedViewModel, {
  LicensePlateChangeDocumentsUploadedViewModelNavigationName,
} from "./licensePlateChangeDocumentsUploadedViewModel";
import { Notice } from "../../../services/NIA/niaService";
import NoticeEntity from "../../../models/notice";

export const LicensePlateChangeModuleNavigationName = "license_plate_change";

@Router.registerRoute({
  route: LicensePlateChangeModuleNavigationName,
  name: Router.Self,
  children: [LicensePlateChangeViewModel, LicensePlateChangeDocumentsUploadedViewModel],
})
export default class LicensePlateChangeNoticeViewModel extends ConductorOneChildActive<ScreenBase> {
  constructor(
    private documentsVMFactory: ReturnType<typeof LicensePlateChangeDocumentsUploadedViewModel.Factory>,
    public localizationService: LocalizationService,
    private licensePlateChangeViewModel: LicensePlateChangeViewModel
  ) {
    super();
    this.nameValue = "licensePlateChange.title";
    this.navigationName = LicensePlateChangeModuleNavigationName;
    this.children.push(this.licensePlateChangeViewModel);
  }

  onInitialize() {
    return this.tryActivateChild(this.licensePlateChangeViewModel);
  }

  async navigate(subPath: string | undefined, params: any) {
    const segments = splitUrlSegments(subPath);
    let childToActivate;
    if (segments[0] === LicensePlateChangeDocumentsUploadedViewModelNavigationName) {
      childToActivate = await this.findNavigationChild(subPath || "");
    } else if (segments[0] === LicensePlateChangeNoticeNavigationName) {
      childToActivate = await this.findNavigationChild(subPath || "");
    }

    if (childToActivate) {
      await this.tryActivateChild(childToActivate);

      if (canNavigate(childToActivate)) {
        await childToActivate.navigate(segments[1], params);
      }
    }

    await this.onChildNavigated(childToActivate);
  }

  async findNavigationChild(navigationName: string) {
    if (navigationName.includes(LicensePlateChangeDocumentsUploadedViewModelNavigationName)) {
      const noticeString = sessionStorage.getItem(Notice.LICENSE_PLATE_CHANGE);

      if (noticeString) {
        const notice = JSON.parse(noticeString) as NoticeEntity;

        if (notice._noticeBase64) {
          return this.documentsVMFactory(notice._noticeBase64, Notice.LICENSE_PLATE_CHANGE);
        }
      }
    }
    return super.findNavigationChild(navigationName);
  }
}
